import { Component } from '@angular/core';

@Component({
    selector: 'app-create-new',
    templateUrl: './create-new.component.html',
    styleUrls: ['./create-new.component.scss'],
    standalone: false
})
export class CaseTechnicalCreateNewComponent {

}
